
const LIVE_URL = "https://testing.api.erp.nsplprojects.com";
// const LOCAL_URL = "http://127.0.0.1:8000";
// export  const MAIN_URL = LIVE_URL;

// testing.api.erp.nsplprojects.com

// const LIVE_URL = "https://api.erp.nsplprojects.com";
const LOCAL_URL = "http://127.0.0.1:8000";
export  const MAIN_URL = LIVE_URL;
export const APPLICATION_KEY = "ems";

/** Headers for fetch() calls (axios interceptor does not apply to fetch). */
export function getApiHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };
  const token = localStorage.getItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  if (APPLICATION_KEY) {
    headers["X-Application-Key"] = APPLICATION_KEY;
  }
  return headers;
}